import { useEffect, useRef } from 'react';
import { camel } from '@pcty/utils';
/**
 * Convert the component id to a useable id for the Form component to manage
 *
 * @param {string} id The id
 * @returns {string}
 * @example
 * const formInputId = useFormInputId(id);
 */
export var useFormInputId = function (id) {
    var formInputId = useRef(camel(id));
    useEffect(function () {
        formInputId.current = camel(id);
    }, [id]);
    return formInputId.current;
};
